<template>
    <div class="page-content">
    <div class="get-to-know-us mb-60">
        <div class="own-title margin-bottom-20">
            About Generali
        </div>
        <div class="ipad-display">
            <carousel :autoplay="false" :nav="false" :items="1" :margin="20" :dots="false" :stagePadding="15">
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/01.png"
                    bgImageDesk="about_generali/iPad/01.png"
                    textImage="about_generali/iPad/01-text.png"
                    textImageDesk="about_generali/iPad/01-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/02.png"
                    bgImageDesk="about_generali/iPad/02.png"
                    textImage="about_generali/iPad/02-text.png"
                    textImageDesk="about_generali/iPad/02-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/03.png"
                    bgImageDesk="about_generali/iPad/03.png"
                    textImage="about_generali//iPad03-text.png"
                    textImageDesk="about_generali/iPad/03-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/04.png"
                    bgImageDesk="about_generali/iPad/04.png"
                    textImage="about_generali/iPad/04-text.png"
                    textImageDesk="about_generali/iPad/04-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/05.png"
                    bgImageDesk="about_generali/iPad/05.png"
                    textImage="about_generali/iPad/05-text.png"
                    textImageDesk="about_generali/iPad/05-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/iPad/06.png"
                    bgImageDesk="about_generali/iPad/06.png"
                    textImage="about_generali/iPad/06-text.png"
                    textImageDesk="about_generali/iPad/06-text.png"
                    :customPosition="false"
                     :customText="true"
                    bar="#94A998"
                    :customContent="false"
                />
            </carousel>
        </div>
        <div class="mobile-display">
            <carousel :autoplay="false" :nav="false" :items="1" :margin="20" :dots="false" :stagePadding="15">
                <SliderIntroWithBg
                    bgImage="about_generali/01.png"
                    bgImageDesk="about_generali/01.png"
                    textImage="about_generali/01-text.png"
                    textImageDesk="about_generali/01-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/02.png"
                    bgImageDesk="about_generali/02.png"
                    textImage="about_generali/02-text.png"
                    textImageDesk="about_generali/02-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/03.png"
                    bgImageDesk="about_generali/03.png"
                    textImage="about_generali/03-text.png"
                    textImageDesk="about_generali/03-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/04.png"
                    bgImageDesk="about_generali/04.png"
                    textImage="about_generali/04-text.png"
                    textImageDesk="about_generali/04-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/05.png"
                    bgImageDesk="about_generali/05.png"
                    textImage="about_generali/05-text.png"
                    textImageDesk="about_generali/05-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/06.png"
                    bgImageDesk="about_generali/06.png"
                    textImage="about_generali/06-text.png"
                    textImageDesk="about_generali/06-text.png"
                    :customPosition="false"
                    bar="#94A998"
                    :customContent="false"
                />
                <SliderIntroWithBg
                    bgImage="about_generali/07.png"
                    bgImageDesk="about_generali/07.png"
                    textImage="about_generali/07-text.png"
                    textImageDesk="about_generali/07-text.png"
                    :customPosition="false"
                    :customText="true"
                    bar="#94A998"
                    :customContent="false"
                />
            </carousel>
        </div>
        <NavLink
            index="0"
        />
    </div>
    </div>
</template>
<style scoped>
    .own-bg {
        background : #1F1F1F;
    }
    .pt-10 {
        padding-top: 10px;
    }
    .mt-10 {
        margin-top: 10px;
    }
    .mb-10 {
        margin-bottom: 10px;
    }
    .mb-60 {
        margin-bottom: 60px;
    }
    .line-30 {
        line-height: 30px;
    }
    .img-height {
        max-height: 500px;
        height: 100%;
        max-width: 100%;
        border-radius: 15px !important;
    }
    .d-block {
        display: block;
    }
    .ovr-caption-mb-10 {
        margin-bottom: 10px !important;
    }
    .ovr-caption-mb-20 {
        margin-bottom: 20px !important;
    }
    @media (max-width: 320px){
        .xs-container-height{
            height: 450px !important;
        }
    }
</style>
<script>
import NavLink from '@/components/NavLink.vue'
import carousel from 'vue-owl-carousel'
import SliderIntroWithBg from '@/components/SliderIntroWithBg.vue'

export default {
    name: 'Get_to_know_us',
    components: {
        NavLink, carousel, SliderIntroWithBg
    }
}
</script>
